import { useEffect } from "react";
import { stripAutofillFromInput } from "../utils/signupFormAutofill";

const SELECTOR =
  'input[type="password"], input[type="email"], input[name="email"], input[name="password"], input[name="password_hash"], input[name="login-email"], input[name="login-password"], input[autocomplete="username"], input[autocomplete="current-password"]';

export default function DisableBrowserAutofill() {
  useEffect(() => {
    const scan = () => {
      document.querySelectorAll(SELECTOR).forEach(stripAutofillFromInput);
    };

    scan();
    const obs = new MutationObserver(() => scan());
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["type", "name", "autocomplete"],
    });

    return () => obs.disconnect();
  }, []);

  return null;
}
